import { useState, useMemo } from 'react';
import PageHero from '../components/PageHero.jsx';
import FilterBar from '../components/FilterBar.jsx';
import CourseCard from '../components/CourseCard.jsx';
import { courses } from '../data/courses.js';
import './Courses.css';

const GRADE_OPTIONS = ['All', '6', '7', '8'];
const CATEGORY_OPTIONS = ['All', 'Core', 'Fine Arts', 'PE', 'Elective'];

const CATEGORY_MAP = {
  'All': null,
  'Core': 'core',
  'Fine Arts': 'fine-arts',
  'PE': 'pe',
  'Elective': 'elective',
};

const FILTER_DEFAULTS = { grade: '6', category: 'All' };

export default function Courses() {
  const [grade, setGrade] = useState(FILTER_DEFAULTS.grade);
  const [category, setCategory] = useState(FILTER_DEFAULTS.category);
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return courses.filter(c => {
      if (grade !== 'All' && String(c.grade) !== grade) return false;
      const cat = CATEGORY_MAP[category];
      if (cat && c.category !== cat) return false;
      if (q) {
        return (
          c.name.toLowerCase().includes(q) ||
          (c.code && c.code.toLowerCase().includes(q)) ||
          (c.description && c.description.toLowerCase().includes(q))
        );
      }
      return true;
    });
  }, [grade, category, search]);

  const hasActiveFilters =
    grade !== FILTER_DEFAULTS.grade ||
    category !== FILTER_DEFAULTS.category ||
    search.trim() !== '';

  function handleFilterChange(key, value) {
    if (key === 'grade') setGrade(value);
    if (key === 'category') setCategory(value);
  }

  function handleClear() {
    setGrade(FILTER_DEFAULTS.grade);
    setCategory(FILTER_DEFAULTS.category);
    setSearch('');
  }

  const filters = [
    { key: 'grade', label: 'Grade', options: GRADE_OPTIONS, value: grade },
    { key: 'category', label: 'Category', options: CATEGORY_OPTIONS, value: category },
  ];

  return (
    <div className="courses">
      <PageHero
        icon="/assets/eagle/page-icons/courses.png"
        title="Courses"
      />
      <p className="courses-subtitle">
        Every class offered at Canyon Ridge for 2026-27 — based on the 2025-26 catalog.
        Confirm elective availability with your counselor at scheduling time.
      </p>

      <FilterBar
        filters={filters}
        search={{ value: search, placeholder: 'Search by name or code…' }}
        onChange={handleFilterChange}
        onSearchChange={setSearch}
        onClear={handleClear}
        hasActiveFilters={hasActiveFilters}
      />

      <p className="courses-count">
        {filtered.length} {filtered.length === 1 ? 'course' : 'courses'}
      </p>

      {filtered.length > 0 ? (
        <div className="courses-grid">
          {filtered.map(course => (
            <CourseCard key={course.id} course={course} />
          ))}
        </div>
      ) : (
        <div className="courses-empty">
          <p>No courses match your filters.</p>
          <button
            type="button"
            className="courses-empty-clear"
            onClick={handleClear}
          >
            Clear filters
          </button>
        </div>
      )}
    </div>
  );
}
